// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__-UV9q","main":"Layout_main__u9muw"};